import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const RoyaltyPayoutsAndCampaigns = () => {
  const sectionRef = useRef(null)

  useEffect(() => {
    const elements = sectionRef.current.querySelectorAll('.fade-in-element')
    gsap.set(elements, { opacity: 0, y: 40 })

    ScrollTrigger.create({
      trigger: sectionRef.current,
      start: 'top 80%',
      once: true,
      onEnter: () => {
        gsap.to(elements, {
          opacity: 1,
          y: 0,
          duration: 0.7,
          stagger: 0.15,
          ease: 'power3.out'
        })
      }
    })

    return () => ScrollTrigger.getAll().forEach(t => t.kill())
  }, [])

  return (
    <section className="royalty-campaigns-section" ref={sectionRef}>
      <div className="alignment-wrapper">
        <h2 className="section-title fade-in-element">Royalty Payouts</h2>
        <ul className="fade-in-element">
          <li>Royalties are paid out in <strong>AiMX Coin</strong>, often on a daily basis.</li>
          <li>Backers must meet a promotion requirement to receive royalties:
            <ul className="nested-list">
              <li>Install the <strong>LinkFi App</strong> and add it to at least one social media profile.</li>
              <li>Agree to promote the campaign they’ve joined via social media.</li>
            </ul>
          </li>
        </ul>

        <h2 className="gold-text section-title fade-in-element">Crowdfunding Campaigns</h2>
        <ul className="fade-in-element">
          <li><strong>Campaign Creation:</strong> Approved Founders create campaigns in BrandHub, setting a percentage of campaign sales to be distributed as royalties to Backers.</li>
          <li><strong>Joining Campaigns:</strong> Backers can join any campaign at <strong>no cost</strong>.</li>
          <li><strong>Packages:</strong>
            <ul className="nested-list">
              <li>Founders can offer up to <strong>5 packages</strong> at different price points.</li>
              <li>Each package may include <strong>perks</strong> such as event tickets, products, or other incentives.</li>
            </ul>
          </li>
          <li><strong>Promotions Feature:</strong>
            <ul className="nested-list">
              <li>Founders can share campaign proceeds with Backers through special promotions.</li>
              <li>Backers earn <strong>scores</strong> and <strong>ranks</strong> within each campaign based on their promotional efforts or other criteria set by the Founder.</li>
              <li>Founders can offer <strong>product rewards</strong> or <strong>cash rewards</strong> based on Backers’ ranks and scores.</li>
              <li>Weekly promotions may reward Backers with the most points earned in a specific timeframe.</li>
            </ul>
          </li>
        </ul>
      </div>
    </section>
  )
}

export default RoyaltyPayoutsAndCampaigns
